module.exports = __webpack_public_path__ + "media/images/v1/search-dark-9781f27353e3e323295296afb6d0093d.png";